export default __webpack_public_path__ + "static/media/Vector-0.9e4eeea8.svg";